const { getAxiosInstance } = require('../connection');

module.exports = {
    ping: function () {
        return getAxiosInstance({
            url:  '/ping',
            method: 'get',
        })
            .then((r) => r.data)
            .then((data) => {
                if (!data || data.toString().toLowerCase() != 'ok') {
                    throw new Error('Invalid response received from API');
                }
                return data;
            });
    },

    verifyCode: function (code) {
        return getAxiosInstance({
            url:  '/verify/code',
            method: 'post',
            data: {
                event_code: code,
            },
        })
            .then((r) => r.data)
            .then((data) => {
                return data;
            });
    },
    connections: function () {
        return getAxiosInstance({
            url:  '/connections',
            method: 'get',
        })
            .then((r) => r.data)
            .then((data) => {
                return data;
            });
    },
    sendEmail: function (senderId, receiverId, subject, message) {
        return getAxiosInstance({
            url:  '/send/email',
            method: 'post',
            data: {
                sender_id: senderId,
                reciever_id: receiverId,
                subject,
                message,
            },
        }).then((r) => r.data);
    },
};
